declare const process: {
  env: {
    [key: string]: string | undefined;
  };
};

function readEnv(keys: string[]): string | undefined {
  const env = process.env as Record<string, string | undefined>;
  for (const key of keys) {
    const value = env[key];
    if (value) {
      return value;
    }
  }
  return undefined;
}

function stripTrailingSlash(url: string): string {
  return url.replace(/\/$/, "");
}

function normalizeApiBase(raw: string | undefined, fallback: string): string {
  const value = stripTrailingSlash(raw || fallback);
  if (value.endsWith("/api")) {
    return value;
  }
  return `${value}/api`;
}

function normalizeAuthBase(raw: string | undefined, fallback: string): string {
  const value = stripTrailingSlash(raw || fallback);
  if (value.endsWith("/api/auth")) {
    return value;
  }
  if (value.endsWith("/api")) {
    return `${value}/auth`;
  }
  return `${value}/api/auth`;
}

const customerBase = normalizeApiBase(
  readEnv(["REACT_APP_CUSTOMER_API_URL", "VITE_CUSTOMER_API_URL"]),
  "https://embeded-customer-1031943580022.us-central1.run.app/api/"
);

export const API_CONFIG = {
  AUTH: {
    BASE_URL: normalizeAuthBase(
      readEnv(["REACT_APP_AUTH_API_URL", "VITE_AUTH_API_URL"]),
      "https://embeded-customer-1031943580022.us-central1.run.app/api/auth"
    ),
    ENDPOINTS: {
      LOGIN: "/login/",
      REFRESH: "/refresh",
      LOGOUT: "/logout",
      FORGOT_PASSWORD: "/forgot-password",
      RESET_PASSWORD: "/reset-password",
      VERIFY_EMAIL: "/verify-email",
    },
  },
  CUSTOMER: {
    BASE_URL: customerBase,
    ENDPOINTS: {
      EMPLOYEES: "/user/employees",
      EMPLOYER: "/employers",
      COMPANIES: "/companies",
      EMPLOYER_ME: "/employers/me",
      COMPANY_ME: "/companies/me",
      NOTIFICATIONS: "/notifications",
      NOTIFICATIONS_UNREAD: "/notifications/unread-count",
      NOTIFICATIONS_READ_ALL: "/notifications/read-all",
      NOTIFICATION_READ: (id: string) => `/notifications/${id}/read`,
      NOTIFICATION_DELETE: (id: string) => `/notifications/${id}`,
      ONBOARD_EMPLOYER: "/onboarding/employer",
    },
  },
  WALLET: {
    BASE_URL:
      readEnv(["REACT_APP_WALLET_API_URL", "VITE_WALLET_API_URL"]) ||
      "https://embeded-wallet-1031943580022.europe-west1.run.app/api",
    ENDPOINTS: {
      WALLETS: "/wallets",
      BALANCE: "/wallets/balance",
      STATISTICS: "/wallets/statistics",
      TRANSACTIONS: "/wallets/transactions",
    },
  },
  TRANSACTION: {
    BASE_URL:
      readEnv(["REACT_APP_TRANSACTION_API_URL", "VITE_TRANSACTION_API_URL"]) ||
      "https://embeded-transaction-1031943580022.us-central1.run.app/api",
    ENDPOINTS: {
      TRANSACTIONS: "/transactions",
      BY_CUSTOMER: (customerId: string) =>
        `/transactions/by-customer/${customerId}`,
      STATISTICS: "/transactions/statistics",
      BY_EMPLOYEE: "/transactions/by-employee",
    },
  },
  LOAN: {
    BASE_URL:
      readEnv(["REACT_APP_LOAN_API_URL", "VITE_LOAN_API_URL"]) ||
      "https://embeded-loan-1031943580022.us-central1.run.app/api",
    ENDPOINTS: {
      APPLICATIONS: "/loan-applications",
      LOANS: "/loans",
      STATISTICS: "/loans/statistics",
      BY_EMPLOYEE: "/loans/by-employee",
    },
  },
  PAYMENT: {
    BASE_URL:
      readEnv(["REACT_APP_PAYMENT_SERVICE_URL", "VITE_PAYMENT_SERVICE_URL"]) ||
      "https://embeded-payment-1031943580022.us-central1.run.app/api",
    ENDPOINTS: {
      PAYMENTS: "/payments",
      STATISTICS: "/payments/statistics",
    },
  },
};

export const APP_CONFIG = {
  NAME:
    readEnv(["REACT_APP_APP_NAME", "VITE_APP_NAME"]) ||
    "VPD Employer Portal",
  VERSION: readEnv(["REACT_APP_APP_VERSION", "VITE_APP_VERSION"]) || "1.0.0",
  ENVIRONMENT:
    readEnv(["REACT_APP_APP_ENVIRONMENT", "VITE_APP_ENVIRONMENT"]) ||
    "development",
  ENABLE_MOCK_DATA:
    readEnv(["REACT_APP_ENABLE_MOCK_DATA", "VITE_ENABLE_MOCK_DATA"]) === "true",
  ENABLE_DEBUG_LOGS:
    readEnv(["REACT_APP_ENABLE_DEBUG_LOGS", "VITE_ENABLE_DEBUG_LOGS"]) ===
    "true",
};
